import { Button, Radio, Text } from "../../../../components";
import Localization from "../../../../localization";
import React, { useCallback } from "react";
import { Flex } from "antd";

const options = [
  Localization.service_edit_alarm_operator.actions_option_1,
  Localization.service_edit_alarm_operator.actions_option_2,
  Localization.service_edit_alarm_operator.actions_option_3,
  Localization.service_edit_alarm_operator.actions_option_4,
  Localization.service_edit_alarm_operator.actions_option_5,
];

const ActionTypes = ({
  gap = "1rem",
  actions = [],
  onSelect = () => {},
  ...props
}) => {
  const renderType = useCallback(({ type, action, title, value }) => {
    return (
      <div {...props}>
        <Text level={5} weight={700} children={title} />
        <Radio.Group
          vertical
          value={action}
          className="m-10-t"
          onChange={(_) => onSelect(type, _.target.value)}
          options={options.map((label, index) => ({
            label,
            value: index.toString(),
          }))}
        />
      </div>
    );
  }, []);

  return (
    <Flex
      vertical
      gap={gap}
      children={React.Children.toArray(actions.map(renderType))}
    />
  );
};
const Actions = ({
  actions = [],
  onNext = () => {},
  onBack = () => {},
  onSelect = () => {},
}) => {
  return (
    <div>
      <Text
        level={5}
        weight="600"
        type="secondary"
        children={`${Localization.general.step} 3: ${Localization.service_edit_alarm_operator.actions_title}`}
      />
      <Text
        type="secondary"
        className="m-5-t"
        children={Localization.service_edit_alarm_operator.actions_desc_1}
      />
      <Text
        type="secondary"
        className="m-5-t"
        children={Localization.service_edit_alarm_operator.actions_desc_2}
      />
      <ActionTypes onSelect={onSelect} actions={actions} className="m-30-t" />
      <Flex gap={"1em"} className="m-30-t">
        <Button
          type="primary"
          onClick={() => onNext({})}
          title={Localization.general.save_and_cont}
        />
        <Button onClick={() => onBack()} title={Localization.general.back} />
      </Flex>
    </div>
  );
};

Actions.options = options;
export default Actions;
